import { render } from "./OfflineLayout.vue?vue&type=template&id=05fc8c99&scoped=true"
import script from "./OfflineLayout.vue?vue&type=script&lang=js"
export * from "./OfflineLayout.vue?vue&type=script&lang=js"

import "./OfflineLayout.vue?vue&type=style&index=0&id=05fc8c99&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fc8c99"]])

export default __exports__